import { useMutation } from '@tanstack/react-query';
import { createProgressToast, ProgressToastFunctions } from 'components/toasts/createProgressToast';
import FormattedMessage from 'features/i18n/FormattedMessage';
import { invalidateWorkspaceInfoQuery } from 'features/workspaces/useGetWorkspaceInfo';
import { useRef } from 'react';
import {
  httpWorkspaceInviteSend,
  WorkspaceInviteSendParams,
} from 'services/backofficeIntegration/http/endpoints/workspace/httpSendWorkspaceInvite';
import { useShowErrorToast } from 'utils/useShowErrorToast';
import { useShowSuccessToast } from 'utils/useShowSuccessToast';

export const useWorkspaceInviteSendMutation = () => {
  const progressToast = useRef<ProgressToastFunctions | null>(null);

  const { showSuccessToast } = useShowSuccessToast();
  const { showErrorToast } = useShowErrorToast();

  return useMutation({
    mutationFn: (params: WorkspaceInviteSendParams) => {
      progressToast.current = createProgressToast(
        <FormattedMessage id="profile.users.users_list.invitation_started" />,
        {
          type: 'info',
        }
      );

      return httpWorkspaceInviteSend.callEndpoint(params);
    },
    onSuccess: () => {
      progressToast.current?.close();
      showSuccessToast();
      invalidateWorkspaceInfoQuery();
    },
    onError: err => showErrorToast(err),
  });
};
